import styled from 'styled-components';
import { setIconColor } from 'modules/utils/cssUtils';
import { theme } from '../theme';
import { Label } from '../typography';
import { mediaQuery } from '../../utils';
import { NavigationType } from './NavigationType';

export const StyledNavigation = styled.div<{
  type?: NavigationType;
}>`
  background-color: ${({theme}) => theme.colors.primaryW};
  width: 100%;

  a {
    display: block;
    width: 100%;
  }

  ${mediaQuery('md')} {
    ${(props) =>
      props.type === NavigationType.Sidebar
        ? `{
        left: 0;
      }`
        : `
        display: flex;
        justify-content: space-evenly;
      `}
  }
`;

export const StyledLabel = styled(Label)<{ type?: NavigationType }>`
  display: none;
  display: block;
  margin-bottom: 1rem;

  ${mediaQuery('md')} {
    ${(props) =>
      props.type === NavigationType.Tabs &&
      `
        display: none;
        `}
  }
`;

export const StyledLink = styled.div<{
  active?: boolean;
  type?: NavigationType;
}>`
  transition: border-left 0.15s linear;
  font-weight: ${theme.fontWeight.thin};
  font-size: var(--main-font-size);
  line-height: var(--main-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
  text-decoration: var(--text-underline);

  padding: 0.188rem 0 0.188rem 0.937rem;
  margin-bottom: calc(1rem - 0.188rem);
  border-left: solid 3px ${({theme}) => theme.colors.primaryW};
  border-bottom: none;
  text-transform: none;

  ${(props) =>
    props.active &&
    `
      border-left: solid 3px ${props.theme.colors.primaryT2};
      color: ${props.theme.colors.primaryT2};      
      border-bottom: none;
    `}

  ${mediaQuery('md')} {
    text-align: left;
    padding-left: 1rem;

    &:hover {
      color: ${({theme}) => theme.colors.primaryK7};
    }

    ${(props) =>
      props.active &&
      `
        &:hover {
          color: ${props.theme.colors.primaryT1};
        }
      `}

    ${(props) =>
      props.type === NavigationType.Sidebar &&
      props.active &&
      `
          &:hover {
            border-left: solid 3px ${props.theme.colors.primaryT1};
          }
        `}
          
    ${(props) =>
      props.type === NavigationType.Tabs &&
      `     
        transition: border-bottom 0.15s linear;
        font-weight: ${theme.fontWeight.bold};
        font-size: var(--h3-font-size);
        line-height: var(--h3-line-height);
        text-transform: uppercase;
        text-align: left;
        padding-left: 1.25rem;
        margin: 0;
        border-bottom: solid 3px ${props.theme.colors.primaryW};
        border-left: none;
        padding-bottom: 0.4rem;
    `}
    
    ${(props) =>
      props.type === NavigationType.Tabs &&
      props.active &&
      ` 
        border-bottom: solid 3px ${props.theme.colors.primaryT2};
        color: ${props.theme.colors.primaryT2};
           
        &:hover {
          border-bottom: solid 3px ${props.theme.colors.primaryT1};
        }
    `}
  }
`;

export const LinkWrapper = styled.div<{ type?: NavigationType }>`
  border-left: solid 1px ${({theme}) => theme.colors.primaryK3};
  border-bottom: none;
  margin: 0;
  padding: 0 0 0.05rem 0;

  ${mediaQuery('md')} {
    ${(props) =>
      props.type === NavigationType.Tabs &&
      `
        margin: 0.55rem 0;
        border-bottom: solid 1px ${props.theme.colors.primaryK3};
        width: 100%;
        height: fit-content;
        border-left: none;
        padding: 0;
      `}
  }
`;

export const AdditionalInfo = styled.div<{
  icon?: boolean;
}>`
  height: 1rem;
  margin-top: 0.2rem;
  display: flex;

  ${(props) =>
    props.icon
      ? `
      ${setIconColor(props.theme.colors.primaryG5)};
      svg {
        height: 1rem;
        width: 1rem;
        margin-right: 0.5rem;
      }
    `
      : `
      h5 {
        color: ${props.theme.colors.primaryK7};
      }
      svg {
        display: none;
      }
    `}
`;
